<template>
  <div class="form-group">
    <label :for="valueKey">
      {{label}}
      <validation-message :required="required" :invalid="invalid" :errorMessage="errorMessage"/>
    </label>
    <input
      :class="modifier"
      :type="type"
      :id="valueKey"
      :name="valueKey"
      v-model.trim="internalValue"
      @focus="onFocus"
      @blur="onBlur"
      :required="required"
      :pattern="pattern"
      :disabled='disabled ? "disabled" : null'
      v-mask="'##/##/####'"
    >
  </div>
</template>

<script>
  import ValueInputBindings from '@mixins/ValueInputBindings'
  import ValidationMessage from '@atoms/ValidationMessage'

  export default {
    mixins: [ValueInputBindings],
    components: { ValidationMessage },
    props: {
      modifier: {
        type: String,
        default: 'form-input'
      },
      pattern: {
        type: String,
        default: null
      },
      type: {
        type: String,
        default: 'text'
      },
      required: {
        type: Boolean,
        default: false
      },
      label: String,
      value: [Number, String, Date],
      valueKey: String,
      disabled: Boolean,
      onFocus: {
        type: Function,
        default() {}
      },
      onBlur: {
        type: Function,
        default() {}
      },
      invalid: {
        type: Boolean,
        default: false
      },
      errorMessage: {
        type: String,
        default: ''
      }
    },
    computed: {
    // invalid() {},
    // errorMessage() {
    //   if (this.required) {
    //   } else if (this.validDate(date)) {
    //   }
    // }
    }
  }
</script>
